import { useState, type ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

const TagEditor = (props) => {
  const [tag, setTag] = useState('');

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && tag && tag.length > 0) {
      //don't fire off onChange()
      e.preventDefault();
      const alreadyExists = props.tags.some(
        (t: string) => t.toLowerCase() === tag.toLowerCase(),
      );
      if (!alreadyExists) {
        // tag is new, so emit a new array with it appended
        props.onChange([...props.tags, tag]);
      }
      // blank input
      setTag('');
    }
  };

  const handleChange = (event) => {
    // strip spaces, hashtags, anything not allowed
    let newTag = '';
    if (props.allowSpaces) {
      newTag = event.target.value.replace(/[^0-9a-zA-Z\s]+/g, '');
    } else {
      newTag = event.target.value.replace(/[\W_]+/g, '');
    }
    setTag(newTag);
  };

  const remove = (tag) => {
    const tags = props.tags.filter(
      (t: string) => t.toLowerCase() !== tag.toLowerCase(),
    );
    props.onChange(tags);
  };

  let placeholder = props.placeholder ? props.placeholder : 'Enter tag here...';

  const items: ReactNode[] = [];
  if (props.tags && props.tags.length > 0) {
    for (var i = 0; i < props.tags.length; i++) {
      var currentTag = props.tags[i];
      items.push(
        <TagEditorItem
          id={currentTag}
          key={currentTag}
          value={currentTag}
          remove={remove}
        />,
      );
    }
  }
  let input: ReactNode = '';
  if (!props.maxItems || props.maxItems > props.tags.length) {
    input = (
      <TextField
        style={{ display: 'inline-block', width: '200px' }}
        disabled={props.disabled}
        value={tag}
        onKeyPress={handleKeyPress}
        onChange={handleChange}
        placeholder={placeholder}
        inputProps={{
          maxLength: props.maxLength ? props.maxLength : undefined,
        }}
      />
    );
  }

  return (
    <div className="tagEditor">
      <div className="flex flex-wrap gap-2">
        {items}
        {input}
      </div>
    </div>
  );
};

const TagEditorItem = (props) => {
  return (
    <div
      className="text-center"
      style={{
        height: '40px',
      }}
      key={props.value}
    >
      <div
        className="flex flex-nowrap whitespace-nowrap"
        style={{
          padding: '9px 12px',
          background: '#f2f4f6',
          borderRadius: '5px',
        }}
      >
        {props.value}
        <a
          className="actionLink ml-2"
          onClick={() => props.remove(props.value)}
        >
          <FontAwesomeIcon
            icon={faTimes}
            className="text-black hover:text-[#626BE7]"
          />
        </a>
      </div>
    </div>
  );
};

export default TagEditor;
